import { Component, Input, OnInit, Output, SimpleChanges, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManagerService, ProfileService, LocalService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import challengePayloadJson from './challengePayloads.json';
import { MatOption, MatSelect } from '@angular/material';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
import { CONSTANTS } from 'src/app/config';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-add-new-activity-challenge',
  templateUrl: './add-new-activity-challenge.component.html',
  styleUrls: ['./add-new-activity-challenge.component.scss']
})
export class AddNewActivityChallengeComponent implements OnInit {

  constructor(private fb: FormBuilder, private profileService: ProfileService,
    private managerService: ManagerService, private popupMessageService: PopupMessageService,
    private el: ElementRef) { }
  downloadExcelModalOpen = false;
  downloadExcelType = '';
  @Input() challengeType: any;
  @ViewChild('select') select!: MatSelect;
  @ViewChild('selectRegion') selectRegion!: MatSelect;
  @Input() isCiscoAdmin!: boolean;
  @Input() editChallengeData: any;
  @Output() submitStatusEvent = new EventEmitter<boolean>();
  challengeResponse: any;
  newTrainingList: any = [];
  trainingListFlag = false;
  newLearningMapList: any = [];
  newContionouseLearningList: any = [];
  editedChallengeData: any;
  createNewChallengeForm: FormGroup = this.fb.group({
    activityName: ['', Validators.required],

    fiscalYear: ['', Validators.required],
    fiscalQuarter: [[], Validators.required],
    startDate: [null, Validators.required],
    endDate: [null, Validators.required],
    assignRegion: [[], Validators.required],
    assignRole: [[], Validators.required],
    partnerCompanies: [[]],
    rewardsCap: [null, [ Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    acronym: ['', Validators.required],
    description: ['', Validators.required],
    challengeRewards: [null, [Validators.required]],
    minEligibleAmt: [null, [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    noOfTickets: ['', Validators.required],
    noOfPeople: [[], Validators.required],
    assignPeople: ['', Validators.required],
    archTypeAndAmountGroup: this.fb.array([this.addArchTypeAndAmountGroup()]),
    assignTraining: [],
    selectallUsers: [false],
    proofofCompletion: [false],
    rewardType: ['POINTS', Validators.required],
    visibilityEndDate: [null],
    budgetSource: ['', Validators.required],
    budgetCapByRegionGroup: this.fb.array([]),
    manualDescription: [''],
    addNewTraining: [false],
    minTrainings: [null],
  });
  roleList: any[] = [];
  regionsList = ['USA', 'CANADA', 'LATAM', 'APJ'];
  userProfile: any = null;
  allUsers: any[] = [];
  allArchitectureTypes: any[] = [];
  learningMapsCourses: any = [{
    id: 'Learning Maps',
    name: 'Learning Maps',
    children: []
  },
  {
    id: 'Continuous Learning',
    name: 'Continuous Learning',
    children: []
  }
  ];
  isLearningMapsReady = false;
  isLearningCoursesReady = false;
  beGeoIdsValidationSuccess = true;
  todayDate = new Date();
  totalCompanyCreditsAvailable: Number = 0;
  bookingTicketError = '';
  architectureTicketError = '';
  trainingTicketError = '';
  allowedTickets: number | null = null;
  fiscalOptionsList: any = [];
  isActiveEdit = false;
  disableSaveButton = false;
  selectedLanguage!: string;
  acronymChallengeNames = {
    'Bookings Challenge': 'BOOK',
    'Architecture Challenge': 'ARCH',
    'Training Challenge': 'TRAN'
  };
  filteredOptions: Observable<any>[] = [];
  docTypeList: any = [];
  showDupsError = false;
  budgetSourceList = ['CONTRA', 'OPEX'];
  fiscalYearList: any = [];
  fiscalQuarterList: any = [];

  readonlyFlag: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '150px',
      minHeight: '0',
      maxHeight: 'auto',
      width: '354px',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',
  };
  categoryTypes: any = [];


rewardEditorConfig: AngularEditorConfig = {
  editable: true,
    spellcheck: true,
    height: '97px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '354px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
  sanitize: true,
  toolbarPosition: 'top',

};
  ngOnInit() {

    this.getAllRoles();
    this.userProfile = LocalService.get('userProfile');
    this.getCompanyCreditsAvailable();
    this.getUsersUnderManager();
    this.getFiscalOptions();
    const lang = localStorage.getItem('selectedLanguage');
    this.selectedLanguage = localStorage.getItem('selectedLanguage') as string;
    this.getdocTypeList();
    this.getEnablementCourseTypes();
    this.getAcPossibleValues();

  }

  getAcPossibleValues() {
    this.managerService.getAcPossibleValues().subscribe((data: any) => {
    }, (err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  addArchTypeAndAmountGroup() {
    return this.fb.group({
      id: [null],
      architectureTypeId: [[], Validators.required],
      architectureBookingsToBeSold: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]]
    });
  }

  addBudgetCapPerRegionGroup(region: any) {
    return this.fb.group({
      region: [region],
      budgetCap: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [''],
      id: [''],
      modifiedBy: ['']
    });
  }

  updateBudgetCapPerRegionGroup(budget: any) {
    return this.fb.group({
      region: [budget.region],
      budgetCap: [budget.amount, [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [budget.createdBy],
      id: [budget.id],
      modifiedBy: ['']
    });
  }

  get archTypeAndAmountGroupArray(): FormArray {
    return <FormArray>this.createNewChallengeForm.get('archTypeAndAmountGroup');
  }

  addNewArchTypeAndAmountGroup() {
    this.archTypeAndAmountGroupArray.push(this.addArchTypeAndAmountGroup());
  }

  removeGroup(index: number) {
    this.archTypeAndAmountGroupArray.removeAt(index);
  }

  get budgetCapByRegionGroupArray(): FormArray {
    return <FormArray>this.createNewChallengeForm.get('budgetCapByRegionGroup');
  }

  createFormByChallengeType(challenge: any) {
    if (challenge === 'Architecture Challenge' || challenge === '아키텍처 챌린지' || challenge === 'アーキテクチャチャレンジ') {
      this.getArchitectureTypes();
      this.createArchitectureForm();

      if (this.editChallengeData && this.editChallengeData.id) {
        this.getArchitectureChallengeDataById(this.editChallengeData.id);
      } else if (this.editChallengeData && this.editChallengeData.isClone) {
        this.challengeResponse = this.editChallengeData;
       this.editedChallengeData = this.editChallengeData;
        this.getArchitectureChallengeData(this.editChallengeData);
      }


    }
    if (challenge === 'Training Challenge' || challenge === '트레이닝 챌린지' || challenge === 'トレーニングチャレンジ') {
      this.getTypesAndLearningMaps();
      this.getTypesAndCourses();
      this.createTrainigForm();
      this.editorConfig;
      if (this.editChallengeData && this.editChallengeData.id) {
        this.getTrainingChallengeDataById(this.editChallengeData.id);
      } else if (this.editChallengeData && this.editChallengeData.isClone) {
        this.challengeResponse = this.editChallengeData;
       this.editedChallengeData = this.editChallengeData;
       this.getTrainingChallengeData(this.editChallengeData);
      }

    }
    if (challenge === 'Bookings Challenge' || challenge === '부킹 챌린지' || challenge === 'ブッキングチャレンジ') {
      this.createBookingForm();
      this.editorConfig;
      if (this.editChallengeData && this.editChallengeData.id) {
        this.getBookingChallengeDataById(this.editChallengeData.id);
      } else if (this.editChallengeData && this.editChallengeData.isClone) {
        this.challengeResponse = this.editChallengeData;
       this.editedChallengeData = this.editChallengeData;
        this.getBookingChallengeData(this.editChallengeData);
      }

    }
  }

  setBudgetCapData(res: any) {
    const budgetData: any[] = [];
    if (res.rewardType === 'POINTS') {
      res.budgetCaps.forEach((budget: any) => {
        budgetData.push(this.updateBudgetCapPerRegionGroup(budget));
      });
    }
    return budgetData;
  }

  getTickets(response: any) {
    let noOfTickets = null;
    if (response && response.rewardType === 'CREDITS') {
      noOfTickets = response.credits;
    }
    if (response && response.rewardType === 'POINTS') {
      noOfTickets = response.points;
    }
    return noOfTickets;
  }

  getBookingChallengeDataById(id: any) {
    this.managerService.getBookingChallengeById(id).subscribe((data) => {
      this.challengeResponse = data.body;
      if (data) {
        const response = data.body;
        this.getBookingChallengeData(response);
      }
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  getArchitectureChallengeDataById(id: any) {
    this.managerService.getArchitectureChallengeById(id).subscribe((data) => {
      this.challengeResponse = data.body;
      if (data) {
        const response = data.body;
        this.getArchitectureChallengeData(response);
      }
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  compare(val1: any, val2: any) {
    if (val1 && val2) {
      return val1.id === val2.id;
    }
  }

  getTrainingChallengeDataById(id: any) {
    this.managerService.getTrainingChallengeById(id).subscribe((data) => {
      this.challengeResponse = data.body;
      if (data) {
        const response = data.body;
       this.getTrainingChallengeData(response);
      }
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isActiveEdit = this.editChallengeData && this.editChallengeData.status === 'ACTIVE' ? true : false;
    if (!this.editChallengeData && this.getArchTypeAndBookingControl().length > 1) {
      this.archTypeAndAmountGroupArray.controls.splice(1);
    }
    this.createFormByChallengeType(changes.challengeType.currentValue);
    if (this.editChallengeData && this.editChallengeData.id) {
      this.checkInactiveStatus();
    }
    this.applyDisabledState();
  }

  applyDisabledState() {
    const activeOrReadonly = this.isActiveEdit || this.readonlyFlag;

    const activityNameCtrl = this.createNewChallengeForm.get('activityName');
    if (activityNameCtrl) {
      if (this.readonlyFlag) {
        activityNameCtrl.disable({emitEvent: false});
      } else {
        activityNameCtrl.enable({emitEvent: false});
      }
    }

    const controlsToDisable = ['startDate', 'endDate', 'visibilityEndDate', 'assignTraining'];
    controlsToDisable.forEach(name => {
      const ctrl = this.createNewChallengeForm.get(name);
      if (!ctrl) { return; }
      if (activeOrReadonly) {
        ctrl.disable({emitEvent: false});
      } else {
        ctrl.enable({emitEvent: false});
      }
    });
  }

  removeParticipantsControls() {
    this.createNewChallengeForm.get('noOfPeople')!.clearValidators();
    this.createNewChallengeForm.get('assignPeople')!.clearValidators();
    this.createNewChallengeForm.get('noOfPeople')!.updateValueAndValidity();
    this.createNewChallengeForm.get('assignPeople')!.updateValueAndValidity();
  }

  removeAssignPartnerControls() {
    this.createNewChallengeForm.get('assignRegion')!.clearValidators();
    this.createNewChallengeForm.get('assignRole')!.clearValidators();
    this.createNewChallengeForm.get('assignRegion')!.updateValueAndValidity();
    this.createNewChallengeForm.get('assignRole')!.updateValueAndValidity();
  }

  createBookingForm() {
    const control = <FormArray>this.createNewChallengeForm.controls['archTypeAndAmountGroup'];
    for (let i = control.length - 1; i >= 0; i--) {
      control.controls[i].get('architectureTypeId')!.clearValidators();
      control.controls[i].get('architectureTypeId')!.updateValueAndValidity();
      control.controls[i].get('architectureBookingsToBeSold')!.clearValidators();
      control.controls[i].get('architectureBookingsToBeSold')!.updateValueAndValidity();
    }
    this.createNewChallengeForm.get('assignTraining')!.clearValidators();
    this.createNewChallengeForm.get('minEligibleAmt')!.setValidators([Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]);
    this.createNewChallengeForm.get('assignTraining')!.updateValueAndValidity();
    this.createNewChallengeForm.get('minEligibleAmt')!.updateValueAndValidity();
    this.createNewChallengeForm.get('minTrainings')!.clearValidators();
    this.createNewChallengeForm.get('minTrainings')!.updateValueAndValidity();
    if (this.isCiscoAdmin) {
      this.removeParticipantsControls();
    }
    if (!this.isCiscoAdmin) {
      this.removeAssignPartnerControls();
    }
    this.createNewChallengeForm.reset();
    this.createNewChallengeForm.patchValue({'rewardType': 'POINTS'});
  }

  createArchitectureForm() {
    const control = <FormArray>this.createNewChallengeForm.controls['archTypeAndAmountGroup'];
    for (let i = control.length - 1; i >= 0; i--) {
      control.controls[i].get('architectureTypeId')!.setValidators([Validators.required]);
      control.controls[i].get('architectureTypeId')!.updateValueAndValidity();
      control.controls[i].get('architectureBookingsToBeSold')!.setValidators([Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]);
      control.controls[i].get('architectureBookingsToBeSold')!.updateValueAndValidity();
    }
    this.createNewChallengeForm.get('minEligibleAmt')!.clearValidators();
    this.createNewChallengeForm.get('assignTraining')!.clearValidators();
    this.createNewChallengeForm.get('minEligibleAmt')!.updateValueAndValidity();
    this.createNewChallengeForm.get('assignTraining')!.updateValueAndValidity();
    this.createNewChallengeForm.get('minTrainings')!.clearValidators();
    this.createNewChallengeForm.get('minTrainings')!.updateValueAndValidity();
    if (this.isCiscoAdmin) {
      this.removeParticipantsControls();
    }
    if (!this.isCiscoAdmin) {
      this.removeAssignPartnerControls();
    }
    this.createNewChallengeForm.reset();
    this.createNewChallengeForm.patchValue({'rewardType': 'POINTS'});
  }

  createTrainigForm() {
    const control = <FormArray>this.createNewChallengeForm.controls['archTypeAndAmountGroup'];
    for (let i = control.length - 1; i >= 0; i--) {
      control.controls[i].get('architectureTypeId')!.clearValidators();
      control.controls[i].get('architectureTypeId')!.updateValueAndValidity();
      control.controls[i].get('architectureBookingsToBeSold')!.clearValidators();
      control.controls[i].get('architectureBookingsToBeSold')!.updateValueAndValidity();
    }
    this.createNewChallengeForm.get('minEligibleAmt')!.clearValidators();
    this.createNewChallengeForm.get('assignTraining')!.updateValueAndValidity();
    this.createNewChallengeForm.get('minEligibleAmt')!.updateValueAndValidity();
    this.createNewChallengeForm.get('minTrainings')!.setValidators([Validators.required]);
    this.createNewChallengeForm.get('minTrainings')!.updateValueAndValidity();
    if (this.isCiscoAdmin) {
      this.removeParticipantsControls();
    }
    if (!this.isCiscoAdmin) {
      this.removeAssignPartnerControls();
    }
    this.createNewChallengeForm.reset();
    this.createNewChallengeForm.patchValue({'rewardType': 'POINTS'});
  }

  getAllRoles() {
    this.profileService.getAllRoles().subscribe(data => {
      if (data) {
        this.roleList = data;
      }
    });
  }

  getUsersUnderManager() {
    this.managerService.getUsersUnderManager(this.userProfile.id).subscribe((data) => {
      if (data) {
        this.allUsers = data.reduce((users: any, item: any) => {
          if (users.find((obj: any) => obj.id === item.id) === undefined) {
            const user = {
              id: item.id,
              fullName: `${item.firstName} ${item.lastName} (${item.username})`
            };
            users.push(user);
          }
          return users;
        }, []);
      }
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  selectedUsersForChallenge() {
    const userCount = (this.createNewChallengeForm.get('assignPeople') as any).value;
    if (userCount) {
      return new Array(userCount.length);
    }
    return [];
  }

  getArchitectureTypes() {
    this.managerService.getArchitectureTypes().subscribe((data) => {
      this.allArchitectureTypes = data;
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  getTypesAndLearningMaps() {
    this.managerService.getTypesAndLearningMaps().subscribe((data) => {
      Object.entries(data).forEach(
        ([key, value]) => {
          const obj = { id: key, name: key, children: value };
          this.learningMapsCourses[0].children.push(obj);
        }
      );
      this.learningMapsCourses[0].children.forEach((item: any, index1: number, array1: any[]) => {
        item.children.forEach((subitem: any, index2: number, array2: any[]) => {
          subitem.id = subitem.id + '-m';
          if (index1 == array1.length - 1 && index2 == array2.length - 1) {
            this.isLearningMapsReady = true;
          }
        });
      });
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  getTypesAndCourses() {
    this.managerService.getTypesAndCourses().subscribe((data) => {
      Object.entries(data).forEach(
        ([key, value]) => {
          const obj = { id: key, name: key, children: value };
          this.learningMapsCourses[1].children.push(obj);
        }
      );
      this.learningMapsCourses[1].children.forEach((item: any, index1: number, array1: any[]) => {
        item.children.forEach((subitem: any, index2: number, array2: any[]) => {
          subitem.id = subitem.id + '-c';
          if (index1 == array1.length - 1 && index2 == array2.length - 1) {
            this.isLearningCoursesReady = true;
          }
        });
      });
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  checkBegeoIdValid() {
    if (this.isCiscoAdmin) {
      if (!(this.createNewChallengeForm.value.partnerCompanies && this.createNewChallengeForm.value.partnerCompanies.length)) {
        return true;
      }
      const begeoIds = this.createNewChallengeForm.value.partnerCompanies.toString();
      const regex = /^\d+(?:,\d+)*$/;
      return regex.test(begeoIds);
    } else {
      return true;
    }
  }

  onFormSubmit() {
    this.disableSaveButton = true;
    this.beGeoIdsValidationSuccess = this.checkBegeoIdValid();
    if (!this.beGeoIdsValidationSuccess) {
      return;
    } else {
      if (this.challengeType === 'Bookings Challenge') {
        if (this.bookingTicketError !== '') {
          return;
        } else {
          let dupsExist = false;
          if (this.createNewChallengeForm.get('proofofCompletion')!.value) {
             dupsExist = this.checkDuplicateDocuments();
          }
          if (dupsExist) {
            this.showDupsError = true;
            this.disableSaveButton = false;
          } else {
            this.submitBookingChallenge();
          }
        }
      }
      if (this.challengeType === 'Training Challenge') {
        if (this.trainingTicketError !== '') {
          return;
        } else {
          let dupsExist = false;
          if (this.createNewChallengeForm.get('proofofCompletion')!.value) {
             dupsExist = this.checkDuplicateDocuments();
          }
          if (dupsExist) {
            this.showDupsError = true;
            this.disableSaveButton = false;
          } else {
            this.submitTrainingChallenge();
          }
        }
      }
      if (this.challengeType === 'Architecture Challenge') {
        if (this.architectureTicketError !== '') {
          return;
        } else {
          let dupsExist = false;
          if (this.createNewChallengeForm.get('proofofCompletion')!.value) {
             dupsExist = this.checkDuplicateDocuments();
          }
          if (dupsExist) {
            this.showDupsError = true;
            this.disableSaveButton = false;
          } else {
            this.submitArchitectureChallenge();
          }
        }
      }
    }
  }

  getBudgetCapsData(formData: any) {
    let budgetCapData: any[] = [];
    if (formData.rewardType === 'POINTS') {
      budgetCapData = formData.budgetCapByRegionGroup.map((budgetRegion: any) => {
        return {
          activityBudgetCapType: 'BUDGETCAP_REGIONAL',
          amount: budgetRegion.budgetCap,
          region: budgetRegion.region,
          id: budgetRegion.id || '',
          createdBy: budgetRegion.createdBy || this.userProfile.id,
          modifiedBy: this.editChallengeData ? this.userProfile.id : ''
        };
      });
    }
    return budgetCapData;
  }

  submitBookingChallenge() {
    const bookingFormData = this.createNewChallengeForm.getRawValue();
    const payloadJson = JSON.parse(JSON.stringify(challengePayloadJson));
    payloadJson.booking.name = bookingFormData.activityName;
    payloadJson.booking.startDate = new Date(bookingFormData.startDate).toISOString();
    payloadJson.booking.completeBy = new Date(bookingFormData.endDate).toISOString();
    payloadJson.booking.regions = bookingFormData.assignRegion || [];
    payloadJson.booking.roleIds = bookingFormData.assignRole || [];
    payloadJson.booking.beGeoIds = bookingFormData.partnerCompanies || [];
    payloadJson.booking.description = bookingFormData.description.replace(/&#160;/g, '');
    payloadJson.booking.acronym = bookingFormData.acronym;
    payloadJson.booking.bookingsToBeSold = Number(bookingFormData.minEligibleAmt);
    payloadJson.booking.credits = bookingFormData.rewardType === 'CREDITS' ? Number(bookingFormData.noOfTickets) : null;
    payloadJson.booking.points = bookingFormData.rewardType === 'POINTS' ? Number(bookingFormData.noOfTickets) : null;
    payloadJson.booking.userIds = bookingFormData.assignPeople;
    payloadJson.booking.winnersCount = bookingFormData.noOfPeople;
    payloadJson.booking.managerId = this.userProfile.id;
    payloadJson.booking.status = this.editChallengeData == null ? 'DRAFT' : this.challengeResponse.status;
    payloadJson.booking.fiscalYear = bookingFormData.fiscalYear;
    payloadJson.booking.fiscalQuarters = bookingFormData.fiscalQuarter;
    payloadJson.booking.winnersCount = bookingFormData.rewardsCap;
    payloadJson.booking.challengeRewards = bookingFormData.challengeRewards.replace(/&#160;/g, '');
    payloadJson.booking.requiredUploadDocuments = bookingFormData.proofofCompletion;
    if (bookingFormData.proofofCompletion) {
      payloadJson.booking.documents = bookingFormData.proofOfCompletionGroup.map((x: any) => {
        return {
          id: x.id,
          name: typeof(x.proofName) === 'string' ? x.proofName : x.proofName.name,
          requiredApproval: x.proofApproval
        };
      });
    } else {
      payloadJson.booking.documents = [];
    }
    payloadJson.booking.rewardType = bookingFormData.rewardType;
    payloadJson.booking.visibilityEndDate = bookingFormData.visibilityEndDate;
    payloadJson.booking.budgetSource = bookingFormData.budgetSource;
    payloadJson.booking.budgetCaps = this.getBudgetCapsData(bookingFormData);
    payloadJson.booking.manualDescription = bookingFormData.manualDescription ? bookingFormData.manualDescription.replace(/&#160;/g, '') : bookingFormData.manualDescription;
    if (this.isCiscoAdmin) {
      payloadJson.booking.category = 'SPECIAL_ACTIVITY';
      payloadJson.booking.creatorType = 'CISCO_ADMIN';
    }

    if (this.editChallengeData && this.editChallengeData.id) {
      payloadJson.booking.id = this.editChallengeData.id;
      this.managerService.updateBookingChallenge(payloadJson.booking).subscribe((data) => {
        if (data) {
          this.popupMessageService.showSuccess('Booking challenge updated successfully', 'success');
          this.createNewChallengeForm.reset();
          this.editChallengeData = null;
          this.submitStatusEvent.emit(true);
          this.disableSaveButton = false;
        }
      },
      err => {
        this.popupMessageService.showError('Something went wrong', 'error');
        this.disableSaveButton = false;
      });
    } else {
      this.managerService.createBookingChallenge(payloadJson.booking).subscribe((data) => {
        if (data.status === 200 || data.status === 201) {
          this.popupMessageService.showSuccess('Booking challenge created successfully', 'success');
          this.createNewChallengeForm.reset();
          this.submitStatusEvent.emit(true);
          this.disableSaveButton = false;
        }
      },
      err => {
        this.popupMessageService.showError('Something went wrong', 'error');
        this.disableSaveButton = false;
      });
    }
  }

  submitTrainingChallenge() {

    const TrainingFormData = this.createNewChallengeForm.getRawValue();
    if (!TrainingFormData.addNewTraining && this.createNewChallengeForm.controls.assignTraining.value.length == 0) {
      this.trainingListFlag = true;
      return;
    } else {
      this.trainingListFlag = false;
    }

    const payloadJson = JSON.parse(JSON.stringify(challengePayloadJson));
    payloadJson.training.name = TrainingFormData.activityName;
    payloadJson.training.startDate = new Date(TrainingFormData.startDate).toISOString();
    payloadJson.training.completeBy = new Date(TrainingFormData.endDate).toISOString();
    payloadJson.training.regions = TrainingFormData.assignRegion || [];
    payloadJson.training.roleIds = TrainingFormData.assignRole || [];
    payloadJson.training.beGeoIds = TrainingFormData.partnerCompanies || [];
    payloadJson.training.description = TrainingFormData.description.replace(/&#160;/g, '');
    payloadJson.training.acronym = TrainingFormData.acronym;
    const courseIds: any[] = [];
    const learningMapIds: any[] = [];
    if ( TrainingFormData.assignTraining) {
      TrainingFormData.assignTraining.map((item: any) => {
        if (item.id.includes('-c')) { courseIds.push({courseId: item.id.replace('-c', ''), optional: item.optional}); } else { learningMapIds.push({learningMapId: item.id.replace('-m', ''), optional: item.optional}); }
      });
    }

    payloadJson.training.courseIdsDTOS = courseIds;
    payloadJson.training.learningMapIdsDTOS = learningMapIds;
    payloadJson.training.credits = TrainingFormData.rewardType === 'CREDITS' ? Number(TrainingFormData.noOfTickets) : null;
    payloadJson.training.points = TrainingFormData.rewardType === 'POINTS' ? Number(TrainingFormData.noOfTickets) : null;
    payloadJson.training.userIds = TrainingFormData.assignPeople;
    payloadJson.training.winnersCount = TrainingFormData.noOfPeople;
    payloadJson.training.managerId = this.userProfile.id;
    payloadJson.training.status = this.editChallengeData == null ? 'DRAFT' : this.challengeResponse.status;
    payloadJson.training.fiscalYear = TrainingFormData.fiscalYear;
    payloadJson.training.fiscalQuarters = TrainingFormData.fiscalQuarter;
    payloadJson.training.winnersCount = TrainingFormData.rewardsCap;
    payloadJson.training.challengeRewards = TrainingFormData.challengeRewards.replace(/&#160;/g, '');
    payloadJson.training.requiredUploadDocuments = TrainingFormData.proofofCompletion;
    if (TrainingFormData.proofofCompletion) {
      payloadJson.training.documents = TrainingFormData.proofOfCompletionGroup.map((x: any) => {
        return {
          id: x.id,
          name: typeof(x.proofName) === 'string' ? x.proofName : x.proofName.name,
          requiredApproval: x.proofApproval
        };
      });
    } else {
      payloadJson.training.documents = [];
    }
    payloadJson.training.rewardType = TrainingFormData.rewardType;
    payloadJson.training.visibilityEndDate = TrainingFormData.visibilityEndDate;
    payloadJson.training.budgetSource = TrainingFormData.budgetSource;
    payloadJson.training.budgetCaps = this.getBudgetCapsData(TrainingFormData);
    payloadJson.training.manualDescription = TrainingFormData.manualDescription ? TrainingFormData.manualDescription.replace(/&#160;/g, '') : TrainingFormData.manualDescription;
    if (this.isCiscoAdmin) {
      payloadJson.training.category = 'SPECIAL_ACTIVITY';
      payloadJson.training.creatorType = 'CISCO_ADMIN';
    }
    if (TrainingFormData.addNewTraining) {
      TrainingFormData.newTrainingGroup.map((training: any) => {
        if (training.trainingType === 'Learning Maps') {
          payloadJson.training.learningMapDTOS.push({
            link: training.link,
            lmIdName: training.trainingId,
            optional: training.optional,
            name: training.name,
            typeId: training.categoryType,

          });
        }
        if (training.trainingType === 'Continuous Learning') {
          payloadJson.training.courseDTOS.push({
            link: training.link,
            name: training.name,
            traceId: training.trainingId,
            optional: training.optional,
            typeId: training.categoryType
          });
        }
      });
    }
    payloadJson.training.minimumNumberOfTrainingsToBeMet = Number(TrainingFormData.minTrainings) || null;

    if (this.editChallengeData && this.editChallengeData.id) {
      payloadJson.training.id = this.editChallengeData.id;
      this.managerService.updateTrainingChallenge(payloadJson.training).subscribe((data) => {
        if (data) {
          this.popupMessageService.showSuccess('Training challenge updated successfully', 'success');
          this.createNewChallengeForm.reset();
          this.editChallengeData = null;
          this.submitStatusEvent.emit(true);
          this.disableSaveButton = false;
        }
      },
      err => {
        this.popupMessageService.showError('Something went wrong', 'error');
        this.disableSaveButton = false;
      });
    } else {
      this.managerService.createTrainingChallenge(payloadJson.training).subscribe((data) => {
        if (data.status === 200 || data.status === 201) {
          this.popupMessageService.showSuccess('Training challenge created successfully', 'success');
          this.createNewChallengeForm.reset();
          this.submitStatusEvent.emit(true);
          this.disableSaveButton = false;
        }
      },
      err => {
        this.popupMessageService.showError('Something went wrong', 'error');
        this.disableSaveButton = false;
      });
    }
  }

  submitArchitectureChallenge() {
    const architectureFormData = this.createNewChallengeForm.getRawValue();
    const payloadJson = JSON.parse(JSON.stringify(challengePayloadJson));
    payloadJson.architecture.name = architectureFormData.activityName;
    payloadJson.architecture.startDate = new Date(architectureFormData.startDate).toISOString();
    payloadJson.architecture.completeBy = new Date(architectureFormData.endDate).toISOString();
    payloadJson.architecture.regions = architectureFormData.assignRegion || [];
    payloadJson.architecture.roleIds = architectureFormData.assignRole || [];
    payloadJson.architecture.beGeoIds = architectureFormData.partnerCompanies || [];
    payloadJson.architecture.description = architectureFormData.description.replace(/&#160;/g, '');
    payloadJson.architecture.architectureTargets = architectureFormData.archTypeAndAmountGroup.map((x: any, index: number) => {
      return {
        id: x.id,
        architectureBookingsToBeSold: Number(x.architectureBookingsToBeSold),
        architectureTypeIds: x.architectureTypeId,
        sortOrder: index
      };
    });
    payloadJson.architecture.credits = architectureFormData.rewardType === 'CREDITS' ? Number(architectureFormData.noOfTickets) : null;
    payloadJson.architecture.points = architectureFormData.rewardType === 'POINTS' ? Number(architectureFormData.noOfTickets) : null;
    payloadJson.architecture.userIds = architectureFormData.assignPeople;
    payloadJson.architecture.winnersCount = architectureFormData.noOfPeople;
    payloadJson.architecture.managerId = this.userProfile.id;
    payloadJson.architecture.acronym = architectureFormData.acronym;
    payloadJson.architecture.status = this.editChallengeData == null ? 'DRAFT' : this.challengeResponse.status;
    payloadJson.architecture.fiscalYear = architectureFormData.fiscalYear;
    payloadJson.architecture.fiscalQuarters = architectureFormData.fiscalQuarter;
    payloadJson.architecture.winnersCount = architectureFormData.rewardsCap;
    payloadJson.architecture.challengeRewards = architectureFormData.challengeRewards.replace(/&#160;/g, '');
    payloadJson.architecture.requiredUploadDocuments = architectureFormData.proofofCompletion;
    if (architectureFormData.proofofCompletion) {
      payloadJson.architecture.documents = architectureFormData.proofOfCompletionGroup.map((x: any) => {
        return {
          id: x.id,
          name: typeof(x.proofName) === 'string' ? x.proofName : x.proofName.name,
          requiredApproval: x.proofApproval
        };
      });
    } else {
      payloadJson.architecture.documents = [];
    }
    payloadJson.architecture.rewardType = architectureFormData.rewardType;
    payloadJson.architecture.visibilityEndDate = architectureFormData.visibilityEndDate;
    payloadJson.architecture.budgetSource = architectureFormData.budgetSource;
    payloadJson.architecture.budgetCaps = this.getBudgetCapsData(architectureFormData);
    payloadJson.architecture.manualDescription = architectureFormData.manualDescription ? architectureFormData.manualDescription.replace(/&#160;/g, '') : architectureFormData.manualDescription;
    if (this.isCiscoAdmin) {
      payloadJson.architecture.category = 'SPECIAL_ACTIVITY';
      payloadJson.architecture.creatorType = 'CISCO_ADMIN';
    }

    if (this.editChallengeData && this.editChallengeData.id) {
      payloadJson.architecture.id = this.editChallengeData.id;
      this.managerService.updateArchitectureChallenge(payloadJson.architecture).subscribe((data) => {
        if (data) {
          this.popupMessageService.showSuccess('Architecture challenge updated successfully', 'success');
          this.createNewChallengeForm.reset();
          this.editChallengeData = null;
          this.submitStatusEvent.emit(true);
          this.disableSaveButton = false;
        }
      },
      err => {
        this.popupMessageService.showError('Something went wrong', 'error');
        this.disableSaveButton = false;
      });
    } else {
      this.managerService.createArchitectureChallenge(payloadJson.architecture).subscribe((data) => {
        if (data.status === 200 || data.status === 201) {
          this.popupMessageService.showSuccess('Architecture challenge created successfully', 'success');
          this.createNewChallengeForm.reset();
          this.submitStatusEvent.emit(true);
          this.disableSaveButton = false;
        }
      },
      err => {
        this.popupMessageService.showError('Something went wrong', 'error');
        this.disableSaveButton = false;
      });
    }
  }

  getCompanyCreditsAvailable() {
    this.managerService.getCompanyCreditsAvailable(this.userProfile.company.id).subscribe((data) => {
      this.totalCompanyCreditsAvailable = data.creditsRemaining;
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  bookingTicketCalculation() {
    this.bookingTicketError = '';
    const numberOfWinners = this.createNewChallengeForm.value.noOfPeople;
    const credits = this.createNewChallengeForm.value.noOfTickets;
    if (Number(numberOfWinners) && Number(credits)) {
      const tickets = numberOfWinners * credits;
      if (tickets > Number(this.totalCompanyCreditsAvailable) && tickets != 0) {
        const totalCompanyCreditsAvailabl: any = this.totalCompanyCreditsAvailable;
        const allowedTicket = totalCompanyCreditsAvailabl / numberOfWinners > 0 ? totalCompanyCreditsAvailabl / numberOfWinners : 0;
        this.bookingTicketError = 'The tickets to each winner should not be more than ' + Math.floor(allowedTicket);
        this.allowedTickets = Math.floor(allowedTicket);
      }
    }
  }

  architectureTicketCalculation() {
    this.architectureTicketError = '';
    const numberOfWinners = this.createNewChallengeForm.value.noOfPeople;
    const credits = this.createNewChallengeForm.value.noOfTickets;
    if (Number(numberOfWinners) && Number(credits)) {
      const tickets = numberOfWinners * credits;
      if (tickets > Number(this.totalCompanyCreditsAvailable) && tickets != 0) {
        const totalCompanyCreditsAvailabl: any = this.totalCompanyCreditsAvailable;
        const allowedTicket = totalCompanyCreditsAvailabl / numberOfWinners > 0 ? totalCompanyCreditsAvailabl / numberOfWinners : 0;
        this.architectureTicketError = 'The tickets to each winner should not be more than ' + Math.floor(allowedTicket);
        this.allowedTickets = Math.floor(allowedTicket);
      }
    }
  }

  trainingTicketCalculation() {
    this.trainingTicketError = '';
    const numberOfWinners = this.createNewChallengeForm.value.noOfPeople;
    const credits = this.createNewChallengeForm.value.noOfTickets;
    if (Number(numberOfWinners) && Number(credits)) {
      const tickets = numberOfWinners * credits;
      if (tickets > Number(this.totalCompanyCreditsAvailable) && tickets != 0) {
        const totalCompanyCreditsAvailabl: any = this.totalCompanyCreditsAvailable;
        const allowedTicket = totalCompanyCreditsAvailabl / numberOfWinners > 0 ? totalCompanyCreditsAvailabl / numberOfWinners : 0;
        this.trainingTicketError = 'The tickets to each winner should not be more than ' + Math.floor(allowedTicket);
        this.allowedTickets = Math.floor(allowedTicket);
      }
    }
  }

  onPeopleSelection() {
    if (this.challengeType === 'Bookings Challenge') {
      this.bookingTicketCalculation();
    }
    if (this.challengeType === 'Training Challenge') {
      this.trainingTicketCalculation();
    }
    if (this.challengeType === 'Architecture Challenge') {
      this.architectureTicketCalculation();
    }
  }

  onParticipantsSelection() {
    this.createNewChallengeForm.controls.noOfPeople.setValue('');
  }

  getSelectedRoleObjects(): any[] {
    const control = this.createNewChallengeForm.get('assignRole');
    const selectedIds: any[] = control ? control.value : [];
    if (!selectedIds || selectedIds.length === 0) {
      return [];
    }
    return (this.roleList as any[]).filter((r: any) => selectedIds.includes(r.id));
  }

  onRoleSelectionChange(roles: any[]): void {
    const control = this.createNewChallengeForm.get('assignRole');
    if (control) {
      control.setValue(roles.map((r: any) => r.id));
    }
  }

  getSelectedArchitectureObjects(group: any): any[] {
    const selectedIds: any[] = group.get('architectureTypeId').value || [];
    if (!selectedIds || selectedIds.length === 0) { return []; }
    return (this.allArchitectureTypes as any[]).filter((a: any) => selectedIds.includes(a.id));
  }

  onArchitectureSelectionChange(group: any, items: any[]): void {
    group.get('architectureTypeId').setValue(items.map((a: any) => a.id));
  }

  getSelectedAssignPeopleObjects(): any[] {
    const control = this.createNewChallengeForm.get('assignPeople');
    const selectedIds: any[] = control ? control.value : [];
    if (!selectedIds || selectedIds.length === 0) { return []; }
    return (this.allUsers as any[]).filter((u: any) => selectedIds.includes(u.id));
  }

  onAssignPeopleChange(users: any[]): void {
    const control = this.createNewChallengeForm.get('assignPeople');
    if (control) { control.setValue(users.map((u: any) => u.id)); }
  }

  getSelectedPeopleCountList(): number[] {
    const list = this.selectedUsersForChallenge();
    const result: number[] = [];
    for (let i = 0; i < list.length; i++) {
      result.push(i + 1);
    }
    return result;
  }

  onRegionSelection(challengeData: any = null) {
    if (this.createNewChallengeForm.controls.rewardType.value === 'POINTS') {
      const regionControl = this.createNewChallengeForm.get('assignRegion');
      const selectedRegions: string[] = regionControl ? regionControl.value || [] : [];
      for (let i = this.budgetCapByRegionGroupArray.value.length - 1; i >= 0; i--) {
        const region = this.budgetCapByRegionGroupArray.value[i].region;
        if (selectedRegions.indexOf(region) === -1) {
          this.budgetCapByRegionGroupArray.removeAt(i);
        }
      }
      selectedRegions.forEach((region: any) => {
        const index = this.budgetCapByRegionGroupArray.value.findIndex((budget: any) => budget.region === region);
        if (index === -1) {
          this.budgetCapByRegionGroupArray.push(this.addBudgetCapPerRegionGroup(region));
        }
      });
      this.createNewChallengeForm.get('budgetSource')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('budgetSource')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('budgetSource')!.setValue(null);
      this.createNewChallengeForm.get('budgetSource')!.clearValidators();
      this.createNewChallengeForm.get('budgetSource')!.updateValueAndValidity();
      while (this.budgetCapByRegionGroupArray.value.length) {
        this.budgetCapByRegionGroupArray.removeAt(0);
      }
    }

    if (this.createNewChallengeForm.controls.rewardType.value === 'POINTS' || this.createNewChallengeForm.controls.rewardType.value === 'CREDITS') {
      this.createNewChallengeForm.get('noOfTickets')!.setValue(this.getTickets(challengeData) || '');
      this.createNewChallengeForm.get('noOfTickets')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('noOfTickets')!.updateValueAndValidity();

      this.createNewChallengeForm.get('manualDescription')!.setValue(null);
      this.createNewChallengeForm.get('manualDescription')!.clearValidators();
      this.createNewChallengeForm.get('manualDescription')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('noOfTickets')!.setValue(null);
      this.createNewChallengeForm.get('noOfTickets')!.clearValidators();
      this.createNewChallengeForm.get('noOfTickets')!.updateValueAndValidity();

      this.createNewChallengeForm.get('manualDescription')!.setValue(challengeData && challengeData.manualDescription || '');
      this.createNewChallengeForm.get('manualDescription')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('manualDescription')!.updateValueAndValidity();
    }
  }

  onPartnerCompaniesFileSelected(rows: any[]) {
    if (!rows || rows.length === 0) {
      this.popupMessageService.showError('The uploaded file is empty', 'error');
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const begeoIdList: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    this.createNewChallengeForm.controls.partnerCompanies.setValue(begeoIdList);
  }

  partnerCompaniesClear() {
    this.createNewChallengeForm.controls.partnerCompanies.setValue([]);
  }

  showDownloadExcelFormatDialog(): void {
    this.downloadExcelType = 'BEGEOID';
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  downloadExcel(): void {
    let columnData = [];
    if (this.downloadExcelType === 'BEGEOID') {
      columnData = [['BEGEOID']];
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      columnData = [['END CUSTOMER GLOBAL HQ ID']];
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      columnData = [['PRODUCT', 'TYPE', 'PAYOUT']];
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      columnData = [['PRODUCT']];
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      columnData = [['PRODUCT', 'TYPE']];
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      columnData = [['PRODUCT SKUS']];
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      columnData = [['PRODUCT FAMILIES']];
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      columnData = [['USER', 'TARGET']];
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      columnData = [['BEGEOID', 'TARGET']];
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      columnData = [['USERIDS']];
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      columnData = [['BEGEOIDS']];
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement('a');
    anchor.href = url;
    if (this.downloadExcelType === 'BEGEOID') {
      anchor.download = 'BEGEOID_LIST.xlsx';
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      anchor.download = 'END_CUSTOMER_LIST.xlsx';
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      anchor.download = 'PRODUCT_PAYOUTS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      anchor.download = 'PRODUCT_LIST.xlsx';
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      anchor.download = 'PRODUCT_LIST_ANY_PRODUCT.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      anchor.download = 'PRODUCT_SKUS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      anchor.download = 'PRODUCT_FAMILIES.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      anchor.download = 'TARGETS_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      anchor.download = 'TARGETS_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      anchor.download = 'PARTICIPANT_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      anchor.download = 'PARTICIPANT_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      anchor.download = 'Participation Challenge Completions Upload.xlsx';
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  begeoIdModalOpen = false;
  begeoIdColumns = [{ field: 'begeoId', header: 'BeGeoId' }];

  get begeoIdRows(): any[] {
    const values = this.createNewChallengeForm.controls.partnerCompanies.value || [];
    return values.map((item: any, i: number) => ({ begeoId: (i + 1) + '. ' + item }));
  }

  openProductDialogContent(i: any) {
    this.begeoIdModalOpen = true;
  }

  closeBegeoIdModal() {
    this.begeoIdModalOpen = false;
  }

  resetForm() {
    if (this.editChallengeData) {
      this.createFormByChallengeType(this.challengeType);
      this.archTypeAndAmountGroupArray.controls.splice(1);
      this.createNewChallengeForm.removeControl('proofOfCompletionGroup');
    } else {
      this.createNewChallengeForm.reset();
      this.createNewChallengeForm.patchValue({'rewardType': 'POINTS'});
    }
    while (this.budgetCapByRegionGroupArray.value.length) {
      this.budgetCapByRegionGroupArray.removeAt(0);
    }
  }
  toggleAllSelection() {
    if (this.createNewChallengeForm.get('selectallUsers')!.value) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.createNewChallengeForm.patchValue({
      selectallUsers: newStatus
    });

  }

  setIdentifier() {
    let acronym = 'AC-' + (this.acronymChallengeNames as any)[this.challengeType];

    let challengeName = '';
    if (this.createNewChallengeForm.value.fiscalYear && this.createNewChallengeForm.value.fiscalQuarter && this.createNewChallengeForm.value.fiscalQuarter.length > 0) {
      const periodStartData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.createNewChallengeForm.value.fiscalYear
        && x.fiscalQuarter == this.createNewChallengeForm.value.fiscalQuarter[0])[0];
      const periodEndData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.createNewChallengeForm.value.fiscalYear
         && x.fiscalQuarter == this.createNewChallengeForm.value.fiscalQuarter[this.createNewChallengeForm.value.fiscalQuarter.length - 1])[0];
      const sd = new Date(periodStartData.startDate);
      const ed = new Date(periodEndData.endDate);
      const startDate = new Date(sd.getUTCFullYear(), sd.getUTCMonth(), sd.getUTCDate());
      const endDate = new Date(ed.getUTCFullYear(), ed.getUTCMonth(), ed.getUTCDate());

      this.createNewChallengeForm.controls.startDate.setValue(startDate);
      this.createNewChallengeForm.controls.endDate.setValue(endDate);
    }

    if (this.createNewChallengeForm.value.activityName) {
      this.createNewChallengeForm.value.activityName.split(' ').filter((e: any) => e.trim()).forEach((x: any) => {
        challengeName += x.charAt(0).toUpperCase();
      });
    }
    let yearVal;
    if (this.createNewChallengeForm.value.fiscalYear) {
      yearVal = this.createNewChallengeForm.value.fiscalYear;
    }
    let quarterVal;
    if (this.createNewChallengeForm.value.fiscalQuarter) {
      quarterVal = this.createNewChallengeForm.value.fiscalQuarter[this.createNewChallengeForm.value.fiscalQuarter.length - 1];
    }
    if (challengeName) {
      acronym = acronym + '-' + challengeName;
    }
    if (quarterVal) {
      acronym = acronym + '-' + quarterVal;
    }
    if (yearVal) {
      acronym = acronym + yearVal;
    }
    this.createNewChallengeForm.controls.acronym.setValue(acronym);
  }

  getFiscalOptions() {
    this.managerService.getActivityFiscalOptions().subscribe((data) => {
      data.forEach((element: any) => {
        element.startDate = new Date(element.startDate).toISOString();
        element.endDate = new Date(element.endDate).toISOString();
      });
      this.fiscalOptionsList = data;
      this.fiscalYearList = Array.from(new Set(data.map((x: any) => x.fiscalYear)));
      this.fiscalQuarterList = Array.from(new Set(data.map((x: any) => x.fiscalQuarter)));
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  getdocTypeList() {
    this.managerService.getDocTypeList().subscribe((data) => {
      this.docTypeList = data;
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  getEnablementCourseTypes() {
    this.managerService.getEnablementCourseTypes().subscribe((data) => {
      this.categoryTypes = data;
    }, err => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  getArchTypeAndBookingControl() {
    return (this.createNewChallengeForm.get('archTypeAndAmountGroup') as FormArray).controls;
  }

  onProofofCompletionChange(event: any) {
    if (event.target.checked) {
      this.createNewChallengeForm.addControl('proofOfCompletionGroup', this.fb.array([this.createProofOfCompletionArray()]));
      this.manageFilteredOptionsList(0);
    } else {
      this.createNewChallengeForm.removeControl('proofOfCompletionGroup');
    }
  }

  createProofOfCompletionArray() {
    return this.fb.group({
      id: [null],
      proofName: ['', Validators.required],
      proofApproval: [false, Validators.required]
    });
  }

  updateProofOfCompletionArray(documentList: any) {
    const updatedArrayList: any[] = [];
    documentList.forEach((proofData: any) => {
      updatedArrayList.push(this.fb.group({
        id: [proofData.id],
        proofName: [this.docTypeList.find((x: any) => x.name === proofData.name) || proofData.name, Validators.required],
        proofApproval: [proofData.requiredApproval, Validators.required]
      }));
    });
    return updatedArrayList;
  }

  getProofOfCompletionGroup(form: any) {
    return form.controls.proofOfCompletionGroup.controls;
  }

  addProofOfCompletionGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('proofOfCompletionGroup');
    control.push(this.createProofOfCompletionArray());
    this.manageFilteredOptionsList(control.length - 1);
  }

  removeProofOfCompletionGroup(index: number) {
    const control = <FormArray>this.createNewChallengeForm.get('proofOfCompletionGroup');
    control.removeAt(index);
    this.filteredOptions.splice(index, 1);
  }

  onAddNewTrainingChange(event: any) {
    if (event.target.checked) {
      this.createNewChallengeForm.addControl('newTrainingGroup', this.fb.array([this.newTrainingGroup()]));
    } else {
      this.createNewChallengeForm.removeControl('newTrainingGroup');
      this.newTrainingList = [];
      this.newLearningMapList = [];
      this.newContionouseLearningList = [];
    }
  }

  newTrainingGroup() {
    return this.fb.group({
      trainingType: ['', Validators.required],
      name: ['', Validators.required],
      link: ['', Validators.required],
      trainingId: [''],
      optional: [false],
      categoryType: ['', Validators.required]
    });
  }

  getAddNewTrainingGroup(form: any) {
    return form.controls.newTrainingGroup.controls;
  }

  addNewTrainingGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('newTrainingGroup');
    control.push(this.newTrainingGroup());
  }

  removeNewTrainingGroup(index: number) {
    const control = <FormArray>this.createNewChallengeForm.get('newTrainingGroup');
    control.removeAt(index);
    this.newLearningMapList = control.value.filter((x: any) => x.trainingType === 'Learning Maps');
    this.newContionouseLearningList = control.value.filter((x: any) => x.trainingType === 'Continuous Learning');
  }

  manageFilteredOptionsList(index: number) {
    const arrayControl = this.createNewChallengeForm.get('proofOfCompletionGroup') as FormArray;
    this.filteredOptions[index] = arrayControl.at(index).get('proofName')!.valueChanges.pipe(
      startWith<any>(''),
      map((value: any) => typeof value === 'string' ? value : value.name),
      map((name: any) => name ? this._filter(name) : this.docTypeList.slice())
    );
  }

  private _filter(name: any) {
    const filterValue = name.toLowerCase();
    return this.docTypeList.filter((option: any) => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(option: any): string | undefined {
    return option ? (typeof(option) === 'string' ? option : option.name) : undefined;
  }

  checkDuplicateDocuments() {
    let dupsExist = false;
    const documentsList = this.createNewChallengeForm.get('proofOfCompletionGroup')!.value.map((x: any) => x.proofName.name || x.proofName);
    if (new Set(documentsList).size !== documentsList.length) {
      dupsExist = true;
    }
    return dupsExist;
  }

  getAllLearningMaps() {
    let learningMaps: any[] = [];
    if (this.createNewChallengeForm.controls.assignTraining.value != null) {
      learningMaps = this.createNewChallengeForm.controls.assignTraining.value.filter((x: any) => x.id.includes('-m'));
    }
    return learningMaps;
  }

  getAllContinuousLearnings() {
    let continuousLearnings: any[] = [];
    if (this.createNewChallengeForm.controls.assignTraining.value != null) {
      continuousLearnings = this.createNewChallengeForm.controls.assignTraining.value.filter((x: any) => x.id.includes('-c'));
    }

    return continuousLearnings;
  }

  clearAllTrainings() {
    this.createNewChallengeForm.patchValue({'assignTraining': []});
  }

  deleteTraining(training: any) {
    const trainingList = this.createNewChallengeForm.controls.assignTraining.value;
    const index = trainingList.findIndex((x: any) => x.id === training.id);
    trainingList.splice(index, 1);
    this.createNewChallengeForm.patchValue({'assignTraining': trainingList});
  }

  setTrainingAsOptional(training: any) {
    const trainingList = this.createNewChallengeForm.controls.assignTraining.value;
    const index = trainingList.findIndex((x: any) => x.id === training.id);
    trainingList[index].optional = !trainingList[index].optional;
    this.createNewChallengeForm.patchValue({'assignTraining': trainingList});
  }

  getNoOfTrainings() {
    const noOfTrainingList: any[] = [];
    const trainingList = this.createNewChallengeForm.controls.assignTraining.value || [];
    const newTraining = <FormArray>this.createNewChallengeForm.get('newTrainingGroup');
    for (let i = 1; i <= trainingList.length; i++) {
      noOfTrainingList.push(i);
    }
    if (newTraining != undefined && newTraining.value.length > 0) {
      let newListIndex: any;
      newTraining.value.forEach((val: any, Index: number) => {
        if (Index == 0) {
          newListIndex = trainingList.length + 1;
        } else {
          newListIndex = newListIndex + 1;
        }
        noOfTrainingList.push(newListIndex);
      });
    }
    if (noOfTrainingList.length == 0) {
      this.createNewChallengeForm.patchValue({'minTrainings': ''});
    }

    return noOfTrainingList;
  }


  getNewLearningMapList() {
   const lmap: any = <FormArray>this.createNewChallengeForm.get('newTrainingGroup')!.value;
    this.newLearningMapList = lmap.filter((x: any) => x.trainingType === 'Learning Maps');
  }

  getNewContinuouseLearningList() {
    const cLeariningList: any = <FormArray>this.createNewChallengeForm.get('newTrainingGroup')!.value;
    this.newContionouseLearningList = cLeariningList.filter((x: any) => x.trainingType === 'Continuous Learning');
  }
  setNewTrainingAsOptional(list: any, index: any, type: any) {
    const test = (this.createNewChallengeForm.get('newTrainingGroup') as FormArray).controls;
    const control = <FormArray>this.createNewChallengeForm.get('newTrainingGroup');

    if (type == 'Learning Maps') {
      const lmap = control.value.filter((x: any) => x.trainingType === 'Learning Maps');
      lmap.forEach((item: any, elmindex: number) => {
        if (elmindex == index) {
          item.optional = !(item.optional);
        }
      });
    } else {
      control.value.filter((x: any) => x.trainingType === 'Continuous Learning').forEach((item: any, elmindex: number) => {
        if (elmindex == index) {
          item.optional = !(item.optional);
        }
    }); }
  }

  getBookingChallengeData(response: any) {
    this.createNewChallengeForm.patchValue({'activityName': response.name});
    this.createNewChallengeForm.patchValue({'startDate': new Date(response.startDate)});
    this.createNewChallengeForm.patchValue({'endDate': new Date(response.completeBy)});
    this.createNewChallengeForm.patchValue({'acronym': response.acronym});
    this.createNewChallengeForm.patchValue({'assignRegion': response.regions});
    this.createNewChallengeForm.patchValue({'assignRole': response.roleIds});
    this.createNewChallengeForm.patchValue({'partnerCompanies': response.beGeoIds});
    this.createNewChallengeForm.patchValue({'description': response.description});
    this.createNewChallengeForm.patchValue({'minEligibleAmt': response.bookingsToBeSold});
    this.createNewChallengeForm.patchValue({'noOfTickets': this.getTickets(response)});
    this.createNewChallengeForm.patchValue({'assignPeople': response.userIds});
    this.createNewChallengeForm.patchValue({'noOfPeople': response.winnersCount});
    this.createNewChallengeForm.patchValue({'fiscalYear': response.fiscalYear});
    this.createNewChallengeForm.patchValue({'fiscalQuarter': response.fiscalQuarters});
    this.createNewChallengeForm.patchValue({'rewardsCap': response.winnersCount > 0 ? response.winnersCount : null});
    this.createNewChallengeForm.patchValue({'visibilityEndDate': response.visibilityEndDate ? new Date(response.visibilityEndDate) : null});
    this.createNewChallengeForm.patchValue({'challengeRewards': response.challengeRewards});
    this.createNewChallengeForm.patchValue({'proofofCompletion': response.requiredUploadDocuments});
    if (response.requiredUploadDocuments) {
      this.createNewChallengeForm.addControl('proofOfCompletionGroup', this.fb.array(this.updateProofOfCompletionArray(response.documents)));
      response.documents.forEach((_: any, index: number) => this.manageFilteredOptionsList(index));
    }
    this.createNewChallengeForm.patchValue({'rewardType': response.rewardType});
    this.createNewChallengeForm.patchValue({'budgetSource': response.budgetSource});
    this.createNewChallengeForm.setControl('budgetCapByRegionGroup', this.fb.array(this.setBudgetCapData(response)));
    this.createNewChallengeForm.patchValue({'manualDescription': response.manualDescription});
    this.onRegionSelection(response);
  }

  getArchitectureChallengeData(response: any) {
    this.createNewChallengeForm.patchValue({'activityName': response.name});
    this.createNewChallengeForm.patchValue({'startDate': new Date(response.startDate)});
    this.createNewChallengeForm.patchValue({'endDate': new Date(response.completeBy)});
    this.createNewChallengeForm.patchValue({'acronym': response.acronym});
    this.createNewChallengeForm.patchValue({'assignRegion': response.regions});
    this.createNewChallengeForm.patchValue({'assignRole': response.roleIds});
    this.createNewChallengeForm.patchValue({'partnerCompanies': response.beGeoIds});
    this.createNewChallengeForm.patchValue({'description': response.description});
    this.createNewChallengeForm.patchValue({'minEligibleAmt': response.architectureBookingsToBeSold});
    this.createNewChallengeForm.patchValue({'noOfTickets': this.getTickets(response)});
    for (let i = 0; i < response.architectureTargets.length; i++) {
      if (i === 0) {
        (this.getArchTypeAndBookingControl()[i].get('id') as any).setValue(response.architectureTargets[i].id);
        (this.getArchTypeAndBookingControl()[i].get('architectureBookingsToBeSold') as any).setValue(response.architectureTargets[i].architectureBookingsToBeSold);
        (this.getArchTypeAndBookingControl()[i].get('architectureTypeId') as any).setValue(response.architectureTargets[i].architectureTypeIds);
      } else {
        this.archTypeAndAmountGroupArray.push(this.fb.group({
          id: [response.architectureTargets[i].id],
          architectureTypeId: [response.architectureTargets[i].architectureTypeIds, [Validators.required]],
          architectureBookingsToBeSold: [response.architectureTargets[i].architectureBookingsToBeSold, Validators.required]
        }));
      }
    }
    this.createNewChallengeForm.patchValue({'assignPeople': response.userIds});
    this.createNewChallengeForm.patchValue({'noOfPeople': response.winnersCount});
    this.createNewChallengeForm.patchValue({'fiscalYear': response.fiscalYear});
    this.createNewChallengeForm.patchValue({'fiscalQuarter': response.fiscalQuarters});
    this.createNewChallengeForm.patchValue({'rewardsCap': response.winnersCount > 0 ? response.winnersCount : null});
    this.createNewChallengeForm.patchValue({'visibilityEndDate': response.visibilityEndDate ? new Date(response.visibilityEndDate) : null});
    this.createNewChallengeForm.patchValue({'challengeRewards': response.challengeRewards});
    this.createNewChallengeForm.patchValue({'proofofCompletion': response.requiredUploadDocuments});
    if (response.requiredUploadDocuments) {
      this.createNewChallengeForm.addControl('proofOfCompletionGroup', this.fb.array(this.updateProofOfCompletionArray(response.documents)));
      response.documents.forEach((_: any, index: number) => this.manageFilteredOptionsList(index));
    }
    this.createNewChallengeForm.patchValue({'rewardType': response.rewardType});
    this.createNewChallengeForm.patchValue({'budgetSource': response.budgetSource});
    this.createNewChallengeForm.setControl('budgetCapByRegionGroup', this.fb.array(this.setBudgetCapData(response)));
    this.createNewChallengeForm.patchValue({'manualDescription': response.manualDescription});
    this.onRegionSelection(response);
  }

  getTrainingChallengeData(response: any) {
    this.createNewChallengeForm.patchValue({'activityName': response.name});
    this.createNewChallengeForm.patchValue({'startDate': new Date(response.startDate)});
    this.createNewChallengeForm.patchValue({'endDate': new Date(response.completeBy)});
    this.createNewChallengeForm.patchValue({'acronym': response.acronym});
    this.createNewChallengeForm.patchValue({'assignRegion': response.regions});
    this.createNewChallengeForm.patchValue({'assignRole': response.roleIds});
    this.createNewChallengeForm.patchValue({'partnerCompanies': response.beGeoIds});
    this.createNewChallengeForm.patchValue({'description': response.description});
    this.createNewChallengeForm.patchValue({'noOfTickets': this.getTickets(response)});
    this.createNewChallengeForm.patchValue({'assignPeople': response.userIds});
    this.createNewChallengeForm.patchValue({'noOfPeople': response.winnersCount});
    this.createNewChallengeForm.patchValue({'fiscalYear': response.fiscalYear});
    this.createNewChallengeForm.patchValue({'fiscalQuarter': response.fiscalQuarters});
    this.createNewChallengeForm.patchValue({'rewardsCap': response.winnersCount > 0 ? response.winnersCount : null});
    this.createNewChallengeForm.patchValue({'visibilityEndDate': response.visibilityEndDate ? new Date(response.visibilityEndDate) : null});
    this.createNewChallengeForm.patchValue({'challengeRewards': response.challengeRewards});
    this.createNewChallengeForm.patchValue({'rewardType': response.rewardType});
    this.createNewChallengeForm.patchValue({'budgetSource': response.budgetSource});
    this.createNewChallengeForm.setControl('budgetCapByRegionGroup', this.fb.array(this.setBudgetCapData(response)));
    const courseList: any[] = [];
    if (response.courseIdsDTOS != null) {
      response.courseIdsDTOS.map((course: any) => {
        courseList.push({id: course.courseId + '-c', optional: course.optional, name: course.name});
      });
    }
    if (response.learningMapIdsDTOS != null) {
      response.learningMapIdsDTOS.map((course: any) => {
        courseList.push({id: course.learningMapId + '-m', optional: course.optional, name: course.name});
      });
    }

    this.createNewChallengeForm.patchValue({'assignTraining': courseList});
    this.createNewChallengeForm.patchValue({'proofofCompletion': response.requiredUploadDocuments});
    if (response.requiredUploadDocuments) {
      this.createNewChallengeForm.addControl('proofOfCompletionGroup', this.fb.array(this.updateProofOfCompletionArray(response.documents)));
      response.documents.forEach((_: any, index: number) => this.manageFilteredOptionsList(index));
    }
    this.createNewChallengeForm.patchValue({'manualDescription': response.manualDescription});
    this.createNewChallengeForm.patchValue({'minTrainings': response.minimumNumberOfTrainingsToBeMet});
    this.onRegionSelection(response);
  }

  checkInactiveStatus() {
    const q = new Date();
    const m = q.getMonth();
    const d = q.getDate();
    const y = q.getFullYear();

    const todayDate = new Date(y, m, d);

   const mydate = new Date(this.editChallengeData.completeBy);


    if ((todayDate > mydate) && this.editChallengeData.status === 'INACTIVE') {
      this.readonlyFlag = true;
    } else {
      this.readonlyFlag = false;


    }

  }
}
